import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Wso2CoreService } from '@services/wso2-core.service';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DadosEmpresaEmpresaComponent } from './dados-empresa-empresa/dados-empresa-empresa.component';
import { DadosEmpresaFiliaisComponent } from './dados-empresa-filiais/dados-empresa-filiais.component';
import { DadosEmpresaEnderecosComponent } from './dados-empresa-enderecos/dados-empresa-enderecos.component';
import { DadosEmpresaContatosComponent } from './dados-empresa-contatos/dados-empresa-contatos.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-dados-empresa',
    templateUrl: './dados-empresa.component.html',
    styleUrls: ['./dados-empresa.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, DadosEmpresaEmpresaComponent, DadosEmpresaFiliaisComponent, DadosEmpresaEnderecosComponent, DadosEmpresaContatosComponent, FooterComponent, CamelCasePipe, CnpjPipe]
})
export class DadosEmpresaComponent implements OnInit {

  private idEmpresaLogada: string;
  public dadosEmpresa: any = null;
  public ramosDeAtividade: any = null;

  constructor(private readonly service: DadosEmpresaService,
    private readonly wso2: Wso2CoreService) { }

  ngOnInit(): void {
    this.idEmpresaLogada = localStorage.idEmpresaLogada;
    this.consultaDadosEmpresa();
    this.consultaDadosDoUsuario();
  }

  consultaDadosDoUsuario() {
    const cpf = sessionStorage.cpf;
    if (cpf !== 'null') {
      this.wso2.contactFindByCpf().pipe(take(1)).subscribe({
          next: (r) => localStorage.portalUserId = r.response[0].portalUserId,
          error: (err) => console.error(err)
        });
    }
  }

  consultaDadosEmpresa() {

    this.service.getDadosEmpresa(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if(response.status === 'OK') {
          this.dadosEmpresa = response.response;
        } else { this.dadosEmpresa = false; }
      },
      error: (error: any) => {
        this.dadosEmpresa = false;
        console.error(error);
      }
    });
  }
}
